// extracted by mini-css-extract-plugin
module.exports = {"superchargeSection":"SuperchargeSection_superchargeSection__E3EzY"};